import { jwtDecode } from "jwt-decode";
import { Navigate, Outlet } from "react-router-dom";

type propsGuard = { children?: any };
interface JwtPayload {
    user_id: number;
}


export const GuardUptc = ({ children }: propsGuard) => {
    const userToken = localStorage.getItem("accessUptc");

    if (!userToken) {
        return <Navigate to="/" replace />;
    }

    try {
        const decoded = jwtDecode<JwtPayload>(userToken);
        const userIdEnv = Number(process.env.REACT_APP_ID_UPTC);
        if (!userIdEnv) {
            console.error("Variable de entorno no definida");
            return <Navigate to="/" replace />;
        }

        if (decoded.user_id !== userIdEnv) {
            return <Navigate to="/" replace />;
        }
    } catch (error) {
        return <Navigate to="/" replace />;
    }

    return children ? children : <Outlet />;
};